import { FieldValues, useForm } from "react-hook-form";
import { Col, Modal, Row } from "@/utils/bootstrap";
import SvgCloseModal from "./SvgCloseModal";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  show: boolean;
  setShow: (show: boolean) => void;
  note: string;
  setNote: (note: string) => void;
}

const EditNoteModal: React.FC<Props> = ({ show, setShow, note, setNote }) => {
  const t = useTranslation();
  const { register, handleSubmit } = useForm({
    defaultValues: { note: note },
  });
  const onSubmit = (data: FieldValues) => {
    setNote(data.note);
    setShow(false);
  };
  return (
    <Modal
      centered
      show={show}
      onHide={() => setShow(false)}
      dialogClassName="messagebox-dialog"
      contentClassName="edit-note-dialog-content"
    >
      <div className="messagebox-closeicon">
        <SvgCloseModal onClick={() => setShow(false)} />
      </div>
      <div className="cart-Item-dialog-title">{t.item_note}</div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <textarea
          rows={3}
          placeholder={t.enter_your_note_here}
          className="edit-note-note"
          {...register("note")}
        />
        <Row className="m-0" style={{ gap: 12 }}>
          <Col className="p-0">
            <div className="w-100">
              <CustomButton
                type={BtnTypes.neutral}
                size={BtnSizes.large}
                radius={BtnRadius.small}
                onClick={() => setShow(false)}
                fullWidth
              >
                {t.discard}
              </CustomButton>
            </div>
          </Col>
          <Col className="p-0">
            <div className="w-100">
              <CustomButton
                isSubmit
                type={BtnTypes.primary}
                size={BtnSizes.large}
                radius={BtnRadius.small}
                onClick={() => {}}
                fullWidth
              >
                {t.save}
              </CustomButton>
            </div>
          </Col>
        </Row>
      </form>
    </Modal>
  );
};

export default EditNoteModal;
